module.exports = __webpack_public_path__ + "img/bg_airplane.40da36f4.jpg";